import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=3e86654e"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupComponent.vue?vue&type=style&index=0&id=3e86654e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports